import React from 'react';
import { LOG_LEVELS } from '../../store/slices/consoleSlice';

function LogFilterBar({ filters, onChange, agents }) {
  return (
    <div className="log-filter">
      <select
        aria-label="Filter by level"
        onChange={(domEvent) => onChange({ ...filters, level: domEvent.target.value })}
        value={filters.level}
      >
        <option value="all">All levels</option>
        {LOG_LEVELS.map((level) => (
          <option key={level} value={level}>{level}</option>
        ))}
      </select>

      <select
        aria-label="Filter by agent"
        onChange={(domEvent) => onChange({ ...filters, agentId: domEvent.target.value })}
        value={filters.agentId}
      >
        <option value="all">All agents</option>
        {agents.map((agent) => (
          <option key={agent.id} value={String(agent.id)}>{agent.name}</option>
        ))}
      </select>

      <input
        aria-label="Search log text"
        onChange={(domEvent) => onChange({ ...filters, query: domEvent.target.value })}
        placeholder="Search text…"
        type="search"
        value={filters.query}
      />
    </div>
  );
}

export default LogFilterBar;
